import { FieldComponentParams } from '@/types/FieldComponent';
import { GraphQLField } from 'graphql';
import FieldComponentFactory from './FieldComponentFactory';

export default class AbstractFieldComponentFactory {
  factories: FieldComponentFactory[];

  constructor(factories: FieldComponentFactory[]) {
    this.factories = factories;
  }

  anyFactorySupport(field: GraphQLField<any, any, any>) {
    return this.factories.some((f) => f.support(field));
  }

  createComponent(componentParams: FieldComponentParams) {
    const factory = this.factories.find((f) => f.support(componentParams.field));

    if (!factory) throw new Error('The pimcore type is not supported.');

    return factory.createComponent(componentParams);
  }

  createComponentsFromFields(fields: GraphQLField<any, any, any>[], hashValues: Record<string, any> = {}) {
    const components = fields
      .filter((f) => this.anyFactorySupport(f))
      .map((field) => {
        const value = hashValues[field.name];
        const params = {
          name: field.name,
          field,
          value,
        };
        return this.createComponent(params);
      });

    return Promise.all(components);
  }
}
